
export default {
  props: {
    bg: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: 'padding flex'
    }
  },
    data(){
        return{
            // isVisible:false
        }
    },
    methods:{

    }
}
